import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  InputAdornment
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import TableCell from 'components/Table/TableCell';
import { CircularProgress, Typography, Divider, Grid } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { observer, inject } from 'mobx-react';
import text from 'texts/translations';
import './TagList.css';

let tagContainerStyle = {
  display: 'flex',
  direction: 'row',
  alignItems: 'flex-start'
};

let tagStyle = {
  margin: '4px',
  borderRadius: '25px',
  border: '1px solid grey',
  background: 'grey',
  maxwidth: '100px',
  display: 'flex'
};

let tagTextStyle = {
  width: '100px'
};

let tagHeaderStyle = {
  position: 'absolute'
};

var ObjectID = require('bson-objectid');

var isTagTaken = false;

@inject('formDataStore')
@observer
class TagList extends Component {
  constructor(props) {
    super(props);
    this.formDataStore = this.props.formDataStore;
    this.tableData = this.props.tableData;
  }

  addIndustry(targetArray, event) {
    const inputObject = {
      _id: ObjectID.generate(),
      name: event.target.value
    };
    this.formDataStore.addObjectToArray(targetArray, inputObject);
  }

  assignValueToProperty(rowID, targetArray, key, event) {
    this.formDataStore.assignValueToProperty(
      rowID,
      targetArray,
      key,
      event.target.value
    );
  }

  removeIndustry(targetArray, id) {
    this.formDataStore.removeObject(targetArray, id);
  }

  render() {
    return (
      <Grid style={tagContainerStyle}>
        {this.formDataStore.customerCase.customer.industryCategories.map(
          (category, index) => {
            return (
              <Grid key={index} style={tagStyle}>
                <Button
                  id={category._id}
                  onClick={event => {
                    this.removeIndustry(
                      'customer.industryCategories',
                      category._id
                    );
                  }}
                >
                  {category.name}
                </Button>
              </Grid>
            );
          }
        )}
        <FormControl>
          <InputLabel htmlFor="age-simple">Lisää</InputLabel>
          <Select
            style={tagTextStyle}
            value={'Lisää'}
            onChange={event => {
              this.addIndustry('customer.industryCategories', event);
            }}
            input={<Input category="industry" />}
            inputProps={{
              category: 'industry'
            }}
          >
            {this.props.tagList.map((choice, index) => {
              isTagTaken = false;
              this.formDataStore.customerCase.customer.industryCategories.map(
                (category, index) => {
                  if (choice == category) {
                    isTagTaken = true;
                  }
                }
              );
              if (!isTagTaken) {
                return (
                  <MenuItem index={index} value={choice}>
                    {choice}
                  </MenuItem>
                );
              } // clean this up later
            })}
          </Select>
        </FormControl>
      </Grid>
    );
  }
}
export default TagList;



// WEBPACK FOOTER //
// ./src/views/LoginPage/TagList/TagList.jsx